export const loadCss = (css: String) => {
    try {
        if (css) {
            const style = document.createElement('style');
            style.textContent = css;
            document.head.append(style);
        }
    } catch (e) {
        console.warn(e.message);
    }
}